// This file was automatically generated and should not be edited.;
import type { SVGProps } from 'react';
import { Ref, forwardRef } from 'react';
const SvgArrowUpRight = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <path
      fill="currentColor"
      d="m5.832 14.528 9.672-5.585-6.665-1.786a1.01 1.01 0 0 1-.71-1.23.996.996 0 0 1 1.222-.706l9.001 2.412a.996.996 0 0 1 .706 1.222l-2.412 9.002a.996.996 0 1 1-1.926-.516l1.786-6.667-9.673 5.586a1.003 1.003 0 0 1-1.366-.366 1.003 1.003 0 0 1 .366-1.367Z"
    />
  </svg>
);
export const ArrowUpRightIcon = forwardRef(SvgArrowUpRight);
